import { useTranslation } from 'react-i18next';

interface SkeletonProps {
  variant?: 'cards' | 'detail';
  count?: number;
}

export const AsyncSkeleton: React.FC<SkeletonProps> = ({ variant = 'cards', count = 3 }) => {
  if (variant === 'detail') {
    return (
      <div className="async-state async-state--skeleton-detail" aria-busy="true" aria-live="polite">
        <div className="skeleton-block skeleton-block--title" />
        <div className="skeleton-block skeleton-block--hero" />
        <div className="skeleton-block skeleton-block--line" />
        <div className="skeleton-block skeleton-block--line skeleton-block--short" />
      </div>
    );
  }

  return (
    <div className="async-state async-state--skeleton-cards" aria-busy="true" aria-live="polite">
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="skeleton-card">
          <div className="skeleton-block skeleton-block--image" />
          <div className="skeleton-block skeleton-block--line" />
          <div className="skeleton-block skeleton-block--line skeleton-block--short" />
        </div>
      ))}
    </div>
  );
};

interface EmptyProps {
  title: string;
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export const AsyncEmpty: React.FC<EmptyProps> = ({ title, message, actionLabel, onAction }) => (
  <div className="async-state async-state--empty">
    <p className="async-state__title">{title}</p>
    {message && <p className="async-state__message">{message}</p>}
    {actionLabel && onAction && (
      <button type="button" className="async-state__action" onClick={onAction}>
        {actionLabel}
      </button>
    )}
  </div>
);

interface ErrorProps {
  message?: string;
  onRetry?: () => void;
}

export const AsyncError: React.FC<ErrorProps> = ({ message, onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="async-state async-state--error" role="alert">
      <p className="async-state__title">{t('common.error')}</p>
      <p className="async-state__message">{message || t('common.loadError')}</p>
      {onRetry && (
        <button type="button" className="async-state__action" onClick={onRetry}>
          {t('common.retry')}
        </button>
      )}
    </div>
  );
};
